<template>
    <div class="page course-page mx-md-auto">
        <v-container class="pb-0" :class="{'pa-0': phoneOnly}">
            <div v-if="loading">

            </div>
            <div v-else-if="lecture">
                <div v-if="lecture.image_url" class="pa-5 pb-2">
                    <v-img :src="lecture.image_url" :height="pcOnly ? 400 : 220" max-width="700" class="rounded-lg mx-auto" />
                </div>

                
                <div class="px-5 medium-text">
                    <div class="rounded mb-2 mt-5 strong-text--text text-center" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 21px;">
                    {{lecture.name}}
                    </div>
                    <div v-if="lecture.description" class="mb-4">
                        <span v-if="lecture.description.length < maxDescriptionLength" v-html="urlify(escapeHtmlText(lecture.description))"></span>
                        <div v-else style="line-height: 1.5; white-space: pre-line;" class="details-text text--text">
                            <span v-html="urlify(escapeHtmlText(showMoreDescription ? lecture.description : lecture.description.slice(0, maxDescriptionLength)))"></span><span v-if="!showMoreDescription">...</span>

                            <a v-ripple v-if="!showMoreDescription" text class="link--text d-inline-block ms-1" @click="showMoreDescription = true" style="white-space: nowrap">عرض المزيد</a>
                            <a v-ripple v-else text class="link--text d-inline-block ms-2" @click="showMoreDescription = false" style="white-space: nowrap">عرض أقل</a>
                        </div>
                        
                    </div>
                </div>

                <v-divider class="mt-4"></v-divider>
                <v-tabs v-model="activeTab" color="primary" light grow class="px-0 mx-0 rounded">
                    <v-tab v-haptic href="#videosTab" style="letter-spacing: 0">
                        <v-icon right>mdi-view-list-outline</v-icon>
                        محتويات المحاضرة
                    </v-tab>
                    <!-- <v-tab v-haptic href="#descriptionTab" style="letter-spacing: 0">
                        <v-icon right>mdi-text</v-icon>
                        الوصف
                    </v-tab> -->
                </v-tabs>
                <v-divider></v-divider>

                <div class="strong-text--text mt-3 px-0" :style="bottomSafeArea ? `padding-bottom: ${bottomSafeInsetPx}px;` : ''">
                    <v-tabs-items v-model="activeTab" class="mb-4">
                        <v-tab-item value="videosTab">

                            <v-alert v-if="platform === 'web' && !miniDerasaPlatform && !wpEnabled" text dark color="primary" class="blink-animation" :class="phoneOnly ? 'ma-3 pa-4' : 'mb-3 px-5 py-3'">
                                <div class="d-flex align-center" :class="{'flex-column justify-center': phoneOnly, 'justify-space-between': pcOnly}">
                                    <div :class="{'text-center': phoneOnly}">
                                        قم بتحميل {{phoneOnly ? 'تطبيق الهاتف' : 'برنامج الديسكتوب'}} حتى تتمكن من مشاهدة المحاضرات
                                    </div>

                                    <div :class="{'ms-4': pcOnly, 'mt-2': phoneOnly}">
                                        <v-btn v-if="pcOnly" depressed :block="phoneOnly" color="primary" tag="a" download :href="appData.desktop_app_url">
                                            <v-icon size="20" class="ml-2" color="white">mdi-monitor</v-icon>
                                            تحميل البرنامج
                                        </v-btn>

                                        <div v-else class="store-badges d-flex align-center justify-start pa-0">
                                            <store-badge type="playstore" width="135px" />
                                            <store-badge type="appstore" width="106px" />
                                        </div>

                                    </div>
                                </div>
                            </v-alert>
                            
                            <!-- <v-alert v-if="!lecture.enable_videos" text dense outlined type="error" icon="mdi-clipboard-text" color="error" class="medium-text font-weight-bold e-link mx-4" v-ripple @click="activeTab = 'examsTab'">
                                لديك امتحانات إجبارية قبل فتح الفيديوهات
                            </v-alert> -->
                            
                            <v-list v-if="items && items.length" class="pa-0 transparent"> 
                                <template v-for="(item, i) in items" >
                                    <v-list-item v-if="item.type === 'exam'" v-haptic :disabled="item.locked" v-ripple="phoneOnly" :key="item.item.id + '-' + i" class="px-7 py-1" :link="phoneOnly">
                                        <v-list-item-icon @click="phoneOnly && !item.locked ? openExam(item.item) : undefined">
                                            <v-icon :color="item.item.needs_attention ? 'error' : 'primary'">mdi-clipboard-text-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content @click="phoneOnly && !item.locked ? openExam(item.item) : undefined">
                                            <v-list-item-title>{{item.item.name}}</v-list-item-title>
                                            <v-list-item-subtitle class="text--text d-flex details-text">
                                                <div v-if="item.item.must_pass" class="d-flex">
                                                    <v-icon :color="item.item.needs_attention ? 'error' : 'success darken-1'" size="16" class="me-1">mdi-{{item.item.needs_attention ? 'license' : 'check'}}</v-icon>
                                                    <span :class="{'font-weight-bold': item.item.needs_attention}">النجاح مطلوب</span>
                                                </div>
                                                <div v-else-if="item.item.must_take" class="d-flex">
                                                    <v-icon :color="item.item.needs_attention ? 'error' : 'strong-text'" size="16" class="me-1">mdi-{{item.item.needs_attention ? 'login' : 'check'}}</v-icon>
                                                    <span>دخول الامتحان مطلوب</span>
                                                </div>

                                                <div v-if="item.item.navigate_to_alternative && item.item.alternative_exam" class="d-flex ms-2">
                                                    <v-icon color="primary" size="16" class="me-1">mdi-reload</v-icon>
                                                    <span>تجربة مع امتحان آخر</span>
                                                    <!-- <span>{{item.item.alternative_exam.name}}</span> -->
                                                </div>
                                                <div v-else-if="item.item.questions_count || item.item.questions_count === 0" class="d-flex ms-2">
                                                    <v-icon color="primary" size="16" class="me-1">mdi-file-question-outline</v-icon>
                                                    <span>{{unitFormat(item.item.questions_count, 'سؤال', 'سؤالين', 'أسئلة')}}</span>
                                                </div>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon class="ms-0">
                                            <v-icon v-if="item.locked" color="muted">mdi-lock</v-icon>

                                            <v-btn v-else-if="pcOnly" :disabled="openingExam" :color="item.item.navigate_to_alternative ? (item.item.needs_attention ? 'red darken-1' : 'success darken-1') : 'primary'" dark :outlined="!item.item.needs_attention" @click.stop.prevent="openExam(item.item)">
                                                {{item.item.navigate_to_alternative ? 'الامتحان البديل' : 'فتح الامتحان'}}
                                                <v-icon right>mdi-chevron-left</v-icon>
                                            </v-btn>
                                            <v-icon v-else>mdi-arrow-left</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                    <v-list-item v-else-if="item.type === 'video'" v-haptic :disabled="item.locked || !item.item.viewable" @click="!item.locked ? playVideo(item.item, i) : undefined" v-ripple="phoneOnly" :key="item.item.id + '-' + i" class="px-7 py-1">
                                        <v-list-item-icon>
                                            <v-icon :color="item.item.viewable ? (item.item.views_limit - item.item.counted_views === 1 ? 'error' : (!item.locked && item.item.seen ? 'success' : 'primary')) : ''">{{!item.locked && item.item.seen ? 'mdi-check-circle' : 'mdi-play-box'}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{item.item.name}}
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="d-flex" :class="{'details-text': pcOnly, 'x-small-text': phoneOnly}">
                                                <template v-if="!item.item.hide_attendance_chips">
                                                    <v-chip v-if="item.item.attendance_required" label x-small class="strong-text--text px-1 me-2" color="grey lighten-2"><b class="me-1">*</b>{{item.item.attendance_chip_text || 'أساسي'}}</v-chip>
                                                </template>
                                                <div v-if="!lecture.expired" class="text--text me-2">
                                                    <span v-if="item.locked" class="muted--text">لا يمكنك مشاهدة الفيديو</span>
                                                    <span v-else-if="item.item.views_limit" :class="{'green--text text--darken-2': item.item.counted_views === 0, 'error--text': item.item.views_limit - item.item.counted_views === 1}">
                                                        تبقى <b>{{item.item.views_limit - item.item.counted_views > 0 ? item.item.views_limit - item.item.counted_views : 0}}</b>
                                                        من
                                                        {{unitFormat(item.item.views_limit, 'مشاهدة', 'مشاهدتين', 'مشاهدات')}}
                                                    </span>
                                                    <span v-else>لا يوجد حد للمشاهدات</span>
                                                </div>
                                                <div>
                                                    <span v-if="lecture.expired" class="error--text">
                                                        <v-icon color="error" small class="me-1">mdi-alert-outline</v-icon>
                                                        المحاضرة منتهية الصلاحية
                                                    </span>
                                                    <span v-else-if="lecture.expiry_days" class="orange--text text--darken-2">صالحة لمدة <b>{{unitFormat(lecture.expiry_days, 'يوم', 'يومين', 'أيام')}}</b></span>
                                                </div>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-icon v-if="item.locked" color="muted">mdi-lock</v-icon>
                                            <v-icon v-else-if="item.item.viewable" color="primary" style="transform: rotate(270deg)">mdi-open-in-new</v-icon>
                                            <v-icon v-else color="warning">mdi-progress-alert</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                    <v-divider v-if="i < items.length -1" :key="'d-' + i" style="border-color: rgba(0,0,0, 0.08)"></v-divider>
                                </template>
                                
                                <v-divider key="divider" style="border-color: rgba(0,0,0, 0.08)"></v-divider>

                                <template v-for="(attachment, i) in attachments" >
                                    <v-list-item v-haptic :key="attachment.id" :href="attachment.url" download class="px-7 py-1">
                                        <v-list-item-icon>
                                            <v-icon color="strong-text">mdi-paperclip</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{attachment.name}}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                <v-chip dark :color="attachment.meta.extension === 'pdf' ? 'deep-orange' : 'primary'" label small class="me-1">
                                                    <v-icon class="me-1">mdi-file</v-icon>
                                                    {{attachment.meta.extension.toUpperCase()}}
                                                </v-chip>
                                                <v-chip label small class="ltr-dir">
                                                    {{attachment.size}}
                                                </v-chip>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-btn as="a" icon large color="secondary" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop :href="attachment.url">
                                                <v-icon size="22">mdi-download</v-icon>
                                            </v-btn>
                                        </v-list-item-icon>
                                    </v-list-item>

                                    <v-divider v-if="i < attachments.length -1" :key="'d' + i" style="border-color: rgba(0,0,0, 0.08)"></v-divider>
                                </template>
                            </v-list>
                        </v-tab-item>
                        <!-- <v-tab-item value="descriptionTab" class="px-6">
                            <div style="line-height: 2.2; white-space: pre-line;" class="medium-text text--text">{{lecture.description}}</div>
                        </v-tab-item> -->
                    </v-tabs-items>
                </div>
            </div>


            <v-dialog v-model="phoneDownloadDialog" max-width="400" overlay-color="#000" overlay-opacity="0.8">
                <v-card>
                    <v-card-title class="mb-2">حمل تطبيق الهاتف</v-card-title>
                    <v-card-subtitle>لكي تتمكن من مشاهدة المحاضرة؛ يجب عليك تحميل تطبيق الهاتف</v-card-subtitle>
                    <v-card-text>
                    
                        <div class="d-flex justify-center align-center">
                            <store-badge type="playstore" width="150px" />
                            <store-badge type="appstore" width="120px" />
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <video-dialog v-model="showVideoDialog" :video="showVideo" :next="nextVideo" :previous="previousVideo" @playNext="playVideo(nextVideo, nextVideoIndex)" @playPrevious="playVideo(previousVideo, previousVideoIndex)" />
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import VideoDialog from '@/components/custom/video-dialog'
import StoreBadge from '@/components/default/store-badge'

import { PrivacyScreen } from '@capacitor-community/privacy-screen';

import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';

export default {
    name: "Courses",
    components: {
        StoreBadge,
        VideoDialog
    },
    props: {
        
    },
    data(){
        return {
            lecture: null,

            activeTab: '',
            show: false,
            loading: false,

            videos: null,
            items: null,
            exams: null,
            attachments: null,

            showMoreDescription: false,

            phoneDownloadDialog: false,

            showVideoDialog: false,
            showVideo: null,
            nextVideo: null,
            nextVideoIndex: null,

            previousVideo: null,
            previousVideoIndex: null,

            openingExam: false,
            
        }
    },
    computed: {
        ...GlobalComputed,
        id(){
            return this.$route.params.id;
        },
        maxDescriptionLength(){
            return this.pcOnly ? 350 : 200;
        },

        loadingSpinner(){
            return this.openingExam;
        },
        examsBadge(){
            let count = 0;
            const exams = this.exams ? this.exams : [];
            exams.forEach(exam=>{
                if (exam.needs_attention){
                    count += 1;
                }
            })
            return count;
        },
    },
    methods: {
        ...GlobalMethods,

        playVideo(video, i){
            this.show = false;
            let wpEnabled = this.wpEnabled;

            if (this.platform === 'web' && !wpEnabled && !this.miniDerasaPlatform){
                if (this.pcOnly){
                    const apiToken = window.localStorage.getItem('tK'); // user oauth token
                    const deepLinkProtocol = process.env.VUE_APP_DESKTOP_APP_PROTOCOL;
                    const url = `${deepLinkProtocol}://video?videoId=${video.id}&token=${apiToken}`
                    window.open(url, '_self')
                }else{
                    // on phone, open download-phone-app dialog
                    this.phoneDownloadDialog = true;
                }
            }else if (this.platform === 'android' || this.platform === 'ios' || this.miniDerasaPlatform || wpEnabled){
                window.setTimeout(()=>{
                    this.showVideoDialog = true;
                    this.showVideo = video;
                    
                    this.nextVideo = null;
                    this.nextVideoIndex = null;
                    this.previousVideo = null;
                    this.previousVideoIndex = null;

                    if (i+1 < this.items.length){
                        const nextItem = this.items[i+1];
                        if (nextItem.type === 'video' && !nextItem.locked){
                            this.nextVideo = nextItem.item;
                            this.nextVideoIndex = i+1;
                        }
                    }
                    if (i-1 >= 0){
                        const previousItem = this.items[i-1];
                        if (previousItem.type === 'video' && !previousItem.locked){
                            this.previousVideo = previousItem.item;
                            this.previousVideoIndex = i-1;
                        }
                    }
                }, 200);
            }
        },
        isWebIOS(){
            if (this.capRunning){
                return false
            }
            var isIOS = /iPad|iPhone|iPod|webOS/.test(navigator.userAgent);
            return isIOS;
        },

        openExam(exam){
            const exam_code = exam.navigate_to_alternative && exam.alternative_exam ? exam.alternative_exam.exam_code : exam.exam_code;
            // get exam details
            if (!this.openingExam){
                this.openingExam = true;
                window.axios.get(`/exams/details?exam_code=${exam_code}`).then(response=>{
                    this.openingExam = false;
                    this.show = false;
                    const examData = response.data.data;
                    window.setTimeout(()=>{
                        this.$router.push({name: 'exams', params: {examData: examData}, query: {course_id: this.lecture.course_id}})
                    }, 600);

                }).catch(error=>{
                    if (error && error.response && error.response.data){
                        const msg = error.response.data;
                        if (msg === 'EXAM_NOT_FOUND'){
                            this.showMsg('الامتحان غير موجود', 'error');
                        }else if (msg === 'EXAM_NOT_STARTED'){
                            this.showMsg('لم يبدأ الامتحان بعد، انتظر حتى يأتي وقت الامتحان', 'error');
                        }else if (msg === 'EXAM_ENDED'){
                            this.showMsg('انتهى الوقت المسموح فيه بدخول الامتحان', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                    }
                    this.openingExam = false;
                })
            }
        },

        loadData(){
            if (!this.loading){
                this.loading = true;
                window.axios.get(`/lectures/${this.id}/contents`).then(response=>{
                    this.setDRM();

                    this.loading = false;
                    this.videos = response.data.videos;
                    this.lecture = response.data.lecture;
                    this.items = response.data.items;
                    this.exams = response.data.exams;
                    this.attachments = response.data.attachments;
                    this.videosDialog = true;

                    this.setDocumentTitle(this.lecture.name, true);
                }).catch(e=>{
                    this.loading = false;
                    if (e.response && e.response.data && e.response.data.course_id){
                        this.$router.push({name: 'course', params: {id: e.response.data.course_id}});
                        this.showMsg('يتعين عليك شراء المحاضرة أولاً', 'error');
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات', 'error');
                    }
                })
            }
        },

        setDRM(){
            if (this.platform === 'android'){
                return PrivacyScreen.enable();
            }
        },
        removeDRM(){
            if (this.platform === 'android'){
                return PrivacyScreen.disable();
            }
        },
        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
        backButtonHandler(){
            if (this.showVideoDialog){
                this.showVideoDialog = false;
            }else{
                this.$router.push({name: 'course', params: {id: this.lecture.course_id}});
            }
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        showVideoDialog(show){
            if (!show){
                this.loadData();
            }
        },
    },
    mounted(){
        if (this.appData && this.appData.lectures_view_layout !== 'seperated'){
            this.$router.push('/not-found');
        }
        this.loadData();

        if (this.capRunning){
            document.addEventListener('backbuttonclicked', this.backButtonHandler);
        }
    },
    beforeDestroy(){
        this.removeDRM();
        if (this.capRunning){
            document.removeEventListener('backbuttonclicked', this.backButtonHandler);
        }
    }
};
</script>

<style lang="scss" scoped>
    @media(max-width: 960px){
        h1{
            line-height: 1.3;
            font-size: 1.8rem;
            font-weight: bold!important;
            text-align: center;
        }
    }
    @media(min-width: 960px){
        .header{
            .container{
                min-height: 270px;
            }
        }
    }
</style>
<style lang="scss">
.v-skeleton-loader__image{
    height: 150px!important;
}
</style>